import type { FaireProductEntity } from "../../entity_types/product";

export const p_knx97ngxss: FaireProductEntity = {
  token: "p_knx97ngxss",
  type: "product",
  name: "BLACK COATED CARGO JEANS",
  brandToken: "b_kmqjsus8ac",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/9bd2390dada70b268eeaf2239aea385626def31559b8e3839a9a6d3abd185a5a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1ae5080de44587e7771a2bfcc4ead703daf8cfb7a446457d7395f3fd3a30b170.jpeg",
  ],
  priceDollars: 332.57,
  description:
    'Black coated cargo jeans with a slim fit and multi-pocket utility design. Features a washed metallic finish, flap and zip pockets, and a bold streetwear look.\n\nSIZE M / WAIST(ROUND) 34" / INSEAM 34" / LEG OPENING(HALF MEASURE)  9 1/2"\n',
  tags: [],
  msrpDollars: 665.13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:59.924Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
